import { render, staticRenderFns } from "./historicalMigration.vue?vue&type=template&id=34a84474"
import script from "./historicalMigration.vue?vue&type=script&lang=js"
export * from "./historicalMigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports